import styles from './index.module.less'
import { Col, Row } from 'antd'

const SectionTitle = props => {
  return (
    <div className={styles.sectionTitle}>
      <Row justify="space-between">
        <Col><span className={styles.sectionTitleText}>{props.children}</span></Col>
        <Col>{props.extra}</Col>
      </Row>
    </div>
  )
}

export default SectionTitle
